// Reusable product catalog. Add future Envago Labs apps here and they will
// automatically render across the site. No UI changes required.

export const products = [
  {
    slug: "tanzeen-plus",
    name: "Tanzeen+",
    status: "available", // available | coming-soon
    category: "Islamic Learning",
    tagline: "AI-powered Islamic learning platform.",
    description:
      "Tanzeen+ is an AI-powered Islamic learning platform that brings the Quran, prayer, and guided learning into one beautifully designed experience. Learn Tajweed with an AI coach, track prayer times, find the Qibla, and grow a daily practice.",
    website: "https://tanzeenplus.com",
    accent: "emerald",
    features: [
      { label: "Quran", icon: "BookOpen" },
      { label: "Prayer Times", icon: "Clock" },
      { label: "Qibla", icon: "Compass" },
      { label: "Tajweed Coach AI", icon: "Mic" },
      { label: "AI Learning Assistant", icon: "Sparkles" },
      { label: "Daily Dhikr", icon: "Heart" },
      { label: "Islamic Articles", icon: "Newspaper" },
      { label: "Premium Subscription", icon: "Crown" },
      { label: "Watch Ads to Unlock Premium", icon: "Gift" },
    ],
    stores: {
      appStore: { url: null, status: "coming-soon" },
      googlePlay: { url: null, status: "coming-soon" },
    },
  },
];

// Placeholder card shown after real products.
export const upcomingPlaceholder = {
  title: "More AI apps coming soon.",
  description:
    "We're building the next generation of AI-powered tools for education, productivity and everyday life. Stay tuned.",
};

export const getProductBySlug = (slug) => products.find((p) => p.slug === slug);
